import { Switch as SwitchToggle } from '@headlessui/react'
import { Controller, useFormContext } from 'react-hook-form'
import { AdFormSchema } from '../AdForm/AdFormTypes'

const OfferRedemption = () => {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext<AdFormSchema>()

  const redemptionEnabled = watch('passDetails.offerRedemption.enable')

  const codeTypeOptions = [
    { id: 'barcode-128', name: '128 Barcode', value: 'BARCODE_128' },
    { id: 'qr-code', name: 'QR Code', value: 'QR_CODE' },
  ]

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Offer Redemption</h3>
      </div>

      {/* Toggle Switch */}
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-gray-700">Toggle on for Barcode/QR code redemption</span>
        <Controller
          control={control}
          name="passDetails.offerRedemption.enable"
          render={({ field: { onChange, value } }) => (
            <SwitchToggle
              checked={value || false}
              onChange={onChange}
              className={`${
                value ? 'bg-blue-600' : 'bg-gray-200'
              } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`}
            >
              <span
                className={`${
                  value ? 'translate-x-6' : 'translate-x-1'
                } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
              />
            </SwitchToggle>
          )}
        />
      </div>

      {redemptionEnabled && (
        <>
          {/* Divider */}
          <hr className="border-gray-200" />

          {/* Code Type Selection */}
          <div className="space-y-3">
            <h4 className="text-sm font-semibold text-gray-900">Code type</h4>
            <Controller
              control={control}
              name="passDetails.offerRedemption.codeType"
              rules={{ required: redemptionEnabled ? 'Code type is required' : false }}
              render={({ field: { onChange, value } }) => (
                <div className="space-y-2">
                  {codeTypeOptions.map(option => (
                    <label key={option.id} className="flex items-center space-x-3 cursor-pointer">
                      <input
                        type="radio"
                        name="codeType"
                        value={option.value}
                        checked={value === option.value}
                        onChange={e => onChange(e.target.value)}
                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 focus:ring-2"
                      />
                      <span className="text-sm font-medium text-gray-700">{option.name}</span>
                    </label>
                  ))}
                </div>
              )}
            />
            {errors.passDetails?.offerRedemption?.codeType && (
              <p className="text-xs text-red-500">{errors.passDetails.offerRedemption.codeType.message}</p>
            )}
          </div>

          {/* Divider */}
          <hr className="border-gray-200" />

          {/* Offer Code / URL Input */}
          <div className="space-y-3">
            <h4 className="text-sm font-semibold text-gray-900">Offer Code / URL</h4>
            <Controller
              control={control}
              name="passDetails.offerRedemption.offerCodeUrl"
              rules={{
                required: redemptionEnabled ? 'Offer code or URL is required' : false,
                validate: value => {
                  if (!redemptionEnabled) return true
                  if (!value || value.trim() === '') {
                    return 'Offer code or URL is required'
                  }
                  return true
                },
              }}
              render={({ field }) => (
                <input
                  {...field}
                  type="text"
                  placeholder="Enter a redemption code or URL"
                  className={`w-full p-3 bg-white border ${
                    errors.passDetails?.offerRedemption?.offerCodeUrl ? 'border-red-500' : 'border-gray-300'
                  } rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition duration-200`}
                />
              )}
            />
            {errors.passDetails?.offerRedemption?.offerCodeUrl && (
              <p className="text-xs text-red-500">{errors.passDetails.offerRedemption.offerCodeUrl.message}</p>
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default OfferRedemption
